import { React, useEffect, useState } from "react";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { useHistory, useLocation } from "react-router-dom";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { LoaderScreen } from "../../components/LoaderScreen";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import EditIcon from "@mui/icons-material/Edit";
import Swal from "sweetalert2";
import request from "../../../Helpers/API";
import { AgregarCategoriaModal } from "./AgregarCategoriaModal";
import EditarCategoriaModal from "./EditarCategoriaModal";

export const CategoriasModelosScreen = () => {
    const history = useHistory();
    const { state } = useLocation();
    const [categorias, setCategorias] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [openModalEditar, setOpenModalEditar] = useState(false);
    const [selectedID, setSelectedID] = useState();

    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    const handleOpenModal = () => {
        setOpenModal(true);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
    };

    const handleOpenModalEditar = (id) => {
        setSelectedID(id);
        setOpenModalEditar(true);
    };

    const handleCloseModalEditar = () => {
        setSelectedID(null);
        setOpenModalEditar(false);
    };
    const cargarCategorias = () => {
        setLoader({ ...loader, mostrar: true });
        request
            .get(`CategoriasModelos/GetListadoCategorias`)
            .then((result) => {
                setCategorias(result);
                setLoader({ ...loader, mostrar: false });
            })
            .catch(() => setLoader({ ...loader, mostrar: false }));
    };

    useEffect(() => {
        if (openModal || openModalEditar)
            return
        cargarCategorias();
    }, [openModal, openModalEditar]);

    const handleCambiarEstatus = async (id_categoria) => {
        const result = await Swal.fire({
            title: "¿Cambiar estatus?",
            text: "¿Deseas cambiar el estatus de esta categoría?",
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Sí, cambiar",
            cancelButtonText: "No, cancelar",
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
        });

        const post = {
            id_categoria: id_categoria,
            descripcion: "",
            estatus: 1,
            usuario: 0
        };
        if (result.isConfirmed) {
            try {
                await request.post(`CategoriasModelos/EditarEstatusCategoria`, post);
                Swal.fire({
                    title: "Estatus actualizado con éxito",
                    icon: "success",
                    confirmButtonText: "OK",
                    confirmButtonColor: "#3085d6",
                    showConfirmButton: true,
                });
                cargarCategorias();
            } catch (error) {
                Swal.fire({
                    title: "Error al actualizar",
                    text: "Ocurrió un error al cambiar el estatus.",
                    icon: "error",
                });
            }
        }
    };

    // console.log(selectedID)
    return (
        <PlantillaScreen
            titulo={`CATEGORIAS DE MODELOS`}
            className={"categorias-modelos-main-screen"}
            className_main={1}
        >
            <div className="categorias-modelos-actions">
                <div
                    className="categorias-modelos-actions-regresar"
                    onClick={() => history.goBack()}
                >
                    <ArrowBackIcon /> Regresar
                </div>
                <div className="buttons">
                    <button
                        className="categorias-modelos-header-agregar-linea"
                        onClick={() => handleOpenModal()}
                    >
                        <AddCircleOutlineIcon /> Agregar
                    </button>
                </div>
            </div>
            <div className="categorias-modelos">
                <LoaderScreen loader={loader} />
                <div className="categorias-modelos-header">
                    <div className="categorias-modelos-header-title">
                        <FormatListNumberedIcon /> Listado de Categorias Registradas
                    </div>
                </div>
                <div className="categorias-modelos-container scroll-4">
                    <table>
                        <thead>
                            <tr>
                                <th>
                                    Descripción
                                </th>
                                <th>
                                    <div>Estatus</div>
                                </th>

                                <th>
                                    <div>Editar</div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {categorias.map((ca) => (
                                <tr key={ca.id_categoria}>
                                    <td className="ta-descripcion">{ca.descripcion}</td>
                                    <td className="ta-estatus"
                                        onClick={() => handleCambiarEstatus(ca.id_categoria)}
                                        style={{ cursor: "pointer" }}
                                    >
                                        {ca.estatus === 0 ? (
                                            <RemoveCircleIcon sx={{ color: "#7b7b7b" }} />
                                        ) : (
                                            <CheckCircleIcon sx={{ color: "#5aa05b" }} />
                                        )}
                                    </td>

                                    <td className="ta-editar">
                                        <div className="categorias-modelos-acciones-listado">
                                            <div
                                                className="boton-editar-categorias-modelos"
                                                onClick={() => handleOpenModalEditar(ca.id_categoria)}
                                            >
                                                <EditIcon /> Editar
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <AgregarCategoriaModal
                    open={openModal}
                    onClose={handleCloseModal}
                //   folio={folio}
                />
                <EditarCategoriaModal
                    open={openModalEditar}
                    onClose={handleCloseModalEditar}
                    id={selectedID}
                />
            </div>
        </PlantillaScreen>
    );
};
